// extracted by mini-css-extract-plugin
module.exports = {"uploadedByCell":"uploadedByCell__OZm7g","tooltip":"tooltip__m4gKL","content":"content__1Urj7"};